<template>
  <div class="product_detail">
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Edit Products - {{ product.name }}</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Marketing</b> /

      <router-link to="/marketing">
        <b>Products</b>
      </router-link>
      /

      <b>Update</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div v-if="allowed_list.includes(product_id)">
      <div v-if="user.roles.some(role => role.name == 'Marketing')">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="home-basic-tab" data-toggle="tab" href="#_details" role="tab"
              aria-controls="_details" aria-selected="true">Details</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="profile-basic-tab" data-toggle="tab" href="#_period" role="tab"
              aria-controls="_period" aria-selected="false">Period</a>
          </li>
        </ul>
  
        <div class="tab-content" id="myTabContent" >
          <div class="tab-pane fade show active bg-white" id="_details" role="tabpanel" aria-labelledby="individual-tab">
            <ProductDetailsPage />
          </div>
  
  
          <div class="tab-pane fade show bg-white" id="_period" role="tabpanel" aria-labelledby="individual-tab">
            <productPeriodPage :product_id="product_id" />
          </div>
        </div>
      </div>
      <div v-else>
        <productPeriodPage :product_id="product_id" />
      </div>
    </div>

    <div v-else>
      <div v-if="user.roles.some(role => role.name == 'Marketing')">
        <ProductDetailsPage />
      </div>
      <div v-else>
        Your don't have permission to view this page.
      </div>
    </div>




  </div>
</template>

<script>
import ProductDetailsPage from "./product-details-page";
import productPeriodPage from "./product-period-page.vue";
import { getById } from "../../../services/ProductService";

export default {
  name: "product-details-index",
  components: {
    ProductDetailsPage, productPeriodPage
  },

  data() {
    return {
      product_id: this.$route.params.id,
      allowed_list: ["6", "15", "49", "54", "1", "12", "14", "5", "3", "4"],
      user: JSON.parse(localStorage.getItem("user")),
      product: {},
      // allowed_list: ["1", "2", "3", "4", "5", "6", "12", "13", "14", "15", "16", "49", "50", "52", "53", "54"]
    };
  },

  methods: {
    async getName() {
      try {
        const response = await getById(this.product_id);
        this.product = response.data;
      } catch (error) {
        this.product = {}
        console.error("Error fetching activity logs:", error);
      }
    }
  },

  async created() {
    await this.getName();
  }

};
</script>
